import React from "react";
import EventCard from "./EventCard";
import ShowMore from "../common/ShowMore";
import axios from "axios";
import DefaultBL from "../../gallery/default/defaultBusinessLogo.png";
import { useQuery } from "react-query";
import EventCardSkeleton from "../common/EventCardSkeleton";

const TabEvents = React.memo(function TabEvents(props) {
  let categoryId = "4";
  if (props.categoryId) {
    categoryId = props.categoryId;
  }
  let report = null;
  if (props.report) {
    report = props.report;
  }

  const { data } = useQuery({
    queryKey: ["tabEvents", props.locationId, categoryId, report],
    queryFn: async () => {
      const options = {
        method: "GET",
        url: process.env.REACT_APP_BASE_URL + "/api/search",
        headers: {
          Authorization: process.env.REACT_APP_API_KEY,
        },
        params: {
          report: report,
          category: categoryId,
          location: props.locationId,
          page: 1,
          limit: 3,
        },
      };

      const response = await axios.request(options);
      return response.data.data;
    },
  });
  // If data is not loaded yet, show skeleton
  if (!data) {
    return (
      <div className="row">
        {Array.from({ length: 3 }).map((_, index) => (
          <div className="col-lg-4 col-md-6 col-sm-6 col-xs-12 card-holder" key={`skeleton-${index}`}>
            <EventCardSkeleton />
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className="row">
      {data
        ? data.map((element, index) => {
            return (
              <div className="col-lg-4 col-md-6 col-sm-6 col-xs-12 card-holder" key={index}>
                <EventCard imageHeight="370px" image={element.image_name ? element.image_path : DefaultBL} title={element.name ? element.name : ""} address1={element.address1 ? element.address1 : ""} location={element.location ? element.location : ""} postalcode={element.postal_code ? element.postal_code : ""} page={element.page ? element.page : ""} type={element.category ? element.category.charAt(0).toUpperCase() + element.category.slice(1) : ""} startTicketDate={element.ticket_start_at} startDate={element.start_date} endDate={element.end_date} showStartDate={element.show_start_date} adultOnly={element.adult_event} detail_url={element.page + "/" + element.slug} price={element.tickets && element.tickets.length > 0 ? element.tickets[0].price : null} eventType={element.event_type} ticketingUrl={element.ticketing_url} internalHasTickets={element.tickets && element.tickets.length > 0} views={element.views} />
              </div>
            );
          })
        : false}
      <ShowMore url={`/search?category=4&location=${props.locationId}&page=1&limit=10`} />
    </div>
  );
});

export default TabEvents;
